import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class MembershipPointsTxnQueryCriteriaClass extends BaseCriteriaModel {
  //txn_hdr
  card_no?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();

  //txn line
  date_valid_from?: Optional<string> = Optional.empty();
  date_valid_to?: Optional<string> = Optional.empty();
  date_txn?: Optional<string> = Optional.empty();
  item_code?: Optional<string> = Optional.empty();
  entity_hdr_guid?: Optional<string> = Optional.empty();
  membership_hdr_guid?: Optional<string> = Optional.empty();
  company_guid?: Optional<string> = Optional.empty();
  branch_guid?: Optional<string> = Optional.empty();
  doc_hdr_guid?: Optional<string> = Optional.empty();
  points_type?: Optional<string> = Optional.empty();

}

export class MembershipPointsTxnCriteriaModelQuery {
  query = '';

  constructor(MembershipPointsTxnCriteriaModel: MembershipPointsTxnQueryCriteriaClass) {

    if (!MembershipPointsTxnCriteriaModel) {
      return;
    }

    this.query += MembershipPointsTxnCriteriaModel.card_no.filter(x => x !== '').map(x => '&card_no=' + x).orElse('');
    this.query += MembershipPointsTxnCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');

    this.query += MembershipPointsTxnCriteriaModel.date_valid_from.filter(x => x !== '').map(x => '&date_valid_from=' + x).orElse('');
    this.query += MembershipPointsTxnCriteriaModel.date_valid_to.filter(x => x !== '').map(x => '&date_valid_to=' + x).orElse('');
    this.query += MembershipPointsTxnCriteriaModel.date_txn.filter(x => x !== '').map(x => '&date_txn=' + x).orElse('');
    this.query += MembershipPointsTxnCriteriaModel.item_code.filter(x => x !== '').map(x => '&item_code=' + x).orElse('');
    this.query += MembershipPointsTxnCriteriaModel.entity_hdr_guid.filter(x => x !== '').map(x => '&entity_hdr_guid=' + x).orElse('');
    this.query += MembershipPointsTxnCriteriaModel.membership_hdr_guid.filter(x => x !== '').map(x => '&membership_hdr_guid=' + x).orElse('');
    this.query += MembershipPointsTxnCriteriaModel.company_guid.filter(x => x !== '').map(x => '&company_guid=' + x).orElse('');
    this.query += MembershipPointsTxnCriteriaModel.branch_guid.filter(x => x !== '').map(x => '&branch_guid=' + x).orElse('');
    this.query += MembershipPointsTxnCriteriaModel.doc_hdr_guid.filter(x => x !== '').map(x => '&doc_hdr_guid=' + x).orElse('');
    this.query += MembershipPointsTxnCriteriaModel.points_type.filter(x => x !== '').map(x => '&points_type=' + x).orElse('');

    this.query += '&status=' + MembershipPointsTxnCriteriaModel.status;
    this.query += '&orderBy=' + MembershipPointsTxnCriteriaModel.orderBy;
    this.query += '&order=' + MembershipPointsTxnCriteriaModel.order;
    this.query += '&offset=' + MembershipPointsTxnCriteriaModel.offset + '&limit=' + MembershipPointsTxnCriteriaModel.limit;
  }
}
